import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pl-4 pr-4"
  }, [_c(VRow, {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VBreadcrumbs, {
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      "items": _vm.editMode ? [_vm.breadCrumbItems[_vm.breadCrumbItems.length - 1]] : _vm.breadCrumbItems
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VBtn, {
          staticStyle: {
            "letter-spacing": "unset",
            "text-transform": "unset",
            "padding": "0px 5px"
          },
          style: {
            cursor: item.disabled ? 'default' : 'pointer'
          },
          attrs: {
            "text": "",
            "color": item.isActiveLayer ? _vm.color : undefined
          },
          on: {
            "click": function ($event) {
              item.disabled ? null : _vm.$emit('click:breadcrumb-layers', {
                layerIndex: item.layerIdx
              });
            }
          }
        }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])];
      }
    }, {
      key: "divider",
      fn: function () {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-chevron-right")])];
      },
      proxy: true
    }])
  })], 1), _vm.editMode ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        _vm.showEditDashboardDialog = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "left": ""
    }
  }, [_vm._v("fal fa-pen")]), _c('span', [_vm._v(_vm._s(_vm.$t('Dashboards.components.toolbar.button.editDashboard')))])], 1)], 1) : _vm._e(), _c(VSpacer), _vm.showEditModeButton !== false ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "true-value": true,
      "color": _vm.color,
      "data-cy": "edit-button",
      "data-cy-enabled": _vm.editMode ? 'true' : 'false',
      "label": _vm.$t('Dashboards.components.toolbar.editMode.' + (_vm.editMode ? 'active' : 'inactive'))
    },
    model: {
      value: _vm.editModeSwitchValue,
      callback: function ($$v) {
        _vm.editModeSwitchValue = $$v;
      },
      expression: "editModeSwitchValue"
    }
  })], 1) : _vm._e(), _vm.editMode ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "data-cy": "add-widget"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:add-widget');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "left": ""
    }
  }, [_vm._v("fal fa-plus")]), _c('span', [_vm._v(_vm._s(_vm.$t('Dashboards.components.toolbar.button.addWidget')))])], 1)], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-dateTime-picker-flat', {
    attrs: {
      "from": _vm.dateRange.start.getTime() / 1000,
      "to": _vm.dateRange.end.getTime() / 1000,
      "isRange": "",
      "container": "div",
      "hide-apply": _vm.editMode,
      "close-on-select": !_vm.editMode
    },
    on: {
      "date:picked": _vm.onDateRangePicked
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('core-button', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "color": _vm.color,
            "data-cy": "date-edit-button"
          }
        }, 'core-button', attrs, false), on), [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "left": ""
          }
        }, [_vm._v("fal fa-calendar-alt")]), !_vm.editMode ? _c('span', [_vm._v(_vm._s(_vm.dateRangeLabel))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Dashboards.components.toolbar.button.openDefaultTimeRangeEditor')))])], 1)];
      }
    }, {
      key: "actions",
      fn: function ({
        apply
      }) {
        return [_vm.editMode ? _c('core-button', {
          attrs: {
            "color": _vm.color
          },
          on: {
            "click": function ($event) {
              return _vm.handleApplyAndSaveClick(apply);
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.toolbar.button.saveAsDefaultDateRange')) + "\n          ")]) : _vm._e()];
      }
    }])
  })], 1), _vm.editMode ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "icon": "",
      "prepend-icon": "fal fa-function"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:parameters');
      }
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "icon": "",
            "loading": _vm.loadingWidgetData,
            "prepend-icon": "fal fa-rotate"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('click:refresh-widget-data');
            }
          }
        }, 'core-button', attrs, false), on))];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dashboards.components.toolbar.button.refreshData')))])])], 1), _vm.showCloseButton !== false ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "icon": "",
      "prepend-icon": "fal fa-times"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1) : _vm._e(), _vm.showFullScreenButton !== false ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "icon": "",
      "prepend-icon": "fal fa-expand"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:fullscreen');
      }
    }
  })], 1) : _vm._e()], 1), _c('upsert-dashboard-dialog', {
    attrs: {
      "dashboard": _vm.activeDashboard
    },
    on: {
      "save": function ($event) {
        _vm.showEditDashboardDialog = false;
      }
    },
    model: {
      value: _vm.showEditDashboardDialog,
      callback: function ($$v) {
        _vm.showEditDashboardDialog = $$v;
      },
      expression: "showEditDashboardDialog"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };